import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from 'axios'

Vue.config.productionTip = false;
import "vant/lib/index.css";
import './plugins/vant.js'
import './utils/rem.js'
import "./assets/css/public.css";
import "./assets/css/icon.css";

Vue.prototype.$axios = axios;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");